// Keyword-optimized practice-area pages for local SEO (Puerto Vallarta)
export const SERVICE_PAGES = {
  "cancelacion-timeshare": {
    slug: "cancelacion-timeshare",
    nav: "Cancelación de Timeshare",
    eyebrow: "ESPECIALIDAD DEL DESPACHO",
    h1: "Cancelación de timeshare en Puerto Vallarta",
    title:
      "Cancelación de Timeshare en Puerto Vallarta | Contreras & Asociados PV",
    description:
      "Cancela tu contrato de tiempo compartido o membresía vacacional en Puerto Vallarta. Abogados especializados y evaluación gratuita. Vidanta, Palace Resorts, Diamond y más.",
    keywords:
      "cancelación timeshare Puerto Vallarta, cancelar tiempo compartido, abogado timeshare México, cancelar membresía vacacional",
    intro: [
      "Si firmaste un contrato de tiempo compartido bajo presión, con información incompleta o simplemente ya no quieres seguir pagando una membresía que no usas, en Puerto Vallarta tienes opciones legales reales para cancelarlo.",
      "En Contreras & Asociados PV analizamos tu contrato a fondo, identificamos cláusulas abusivas o vicios en el consentimiento y construimos la estrategia de salida que mejor se ajusta a tu caso, sin promesas vacías.",
    ],
    includes: [
      "Revisión gratuita de tu contrato e historial de pagos",
      "Identificación de cláusulas abusivas y vicios del consentimiento",
      "Negociación directa con la empresa desarrolladora",
      "Representación ante PROFECO y CONDUSEF",
      "Recuperación de pagos cuando procede",
      "Carta de cancelación formal y seguimiento hasta el cierre",
    ],
    closing:
      "Atendemos a clientes de México, Estados Unidos y Canadá, en español e inglés, y en la mayoría de los trámites no necesitas presentarte en México.",
  },
  "derecho-inmobiliario": {
    slug: "derecho-inmobiliario",
    nav: "Derecho Inmobiliario",
    eyebrow: "ÁREA DE PRÁCTICA",
    h1: "Abogado de Derecho Inmobiliario en Puerto Vallarta",
    title:
      "Abogado de Derecho Inmobiliario en Puerto Vallarta | Contreras & Asociados PV",
    description:
      "Asesoría legal inmobiliaria en Puerto Vallarta: compraventa, fideicomisos costeros, due diligence y conflictos de propiedad para extranjeros y nacionales.",
    keywords:
      "abogado inmobiliario Puerto Vallarta, fideicomiso costero, compraventa propiedad México, due diligence inmobiliario",
    intro: [
      "Comprar o vender una propiedad en la Bahía de Banderas implica un marco legal particular, sobre todo para extranjeros. Un error en el contrato o en el fideicomiso puede costar muy caro.",
      "Te acompañamos en cada etapa de la operación inmobiliaria para que tu inversión en Puerto Vallarta y la Riviera Nayarit esté protegida de principio a fin.",
    ],
    includes: [
      "Compraventa de inmuebles y revisión de contratos",
      "Constitución y administración de fideicomisos costeros",
      "Due diligence de propiedad y verificación registral",
      "Resolución de conflictos y controversias de propiedad",
      "Asesoría a inversionistas extranjeros y nacionales",
    ],
    closing:
      "Conocemos la legislación aplicable a la zona turística y trabajamos con notarías de confianza para dar certeza a tu operación.",
  },
  "derecho-civil": {
    slug: "derecho-civil",
    nav: "Derecho Civil",
    eyebrow: "ÁREA DE PRÁCTICA",
    h1: "Abogado de Derecho Civil en Puerto Vallarta",
    title:
      "Abogado de Derecho Civil en Puerto Vallarta | Contratos y Litigio",
    description:
      "Abogados de derecho civil en Puerto Vallarta: contratos, responsabilidad civil, controversias patrimoniales y representación en juicios civiles.",
    keywords:
      "abogado derecho civil Puerto Vallarta, contratos, responsabilidad civil, juicio civil México",
    intro: [
      "El derecho civil rige buena parte de las relaciones y acuerdos de la vida diaria. Contar con un contrato bien redactado y con una defensa sólida marca la diferencia.",
      "En Contreras & Asociados PV diseñamos una estrategia clara desde la primera consulta, ya sea para prevenir un conflicto o para defender tus derechos en juicio.",
    ],
    includes: [
      "Elaboración y revisión de contratos civiles",
      "Responsabilidad civil y daños y perjuicios",
      "Controversias patrimoniales y de propiedad",
      "Representación en juicios civiles",
      "Convenios y transacciones",
    ],
    closing:
      "Cada caso es atendido directamente por un licenciado titulado, con comunicación constante sobre el avance de tu asunto.",
  },
  "derecho-familiar": {
    slug: "derecho-familiar",
    nav: "Derecho Familiar",
    eyebrow: "ÁREA DE PRÁCTICA",
    h1: "Abogado de Derecho Familiar en Puerto Vallarta",
    title:
      "Abogado de Derecho Familiar en Puerto Vallarta | Divorcios y Custodia",
    description:
      "Derecho familiar en Puerto Vallarta: divorcios, pensiones alimenticias, custodia y sucesiones, con acompañamiento humano y una defensa firme de tus derechos.",
    keywords:
      "abogado derecho familiar Puerto Vallarta, divorcio, pensión alimenticia, custodia, sucesiones",
    intro: [
      "Los asuntos familiares requieren sensibilidad y, al mismo tiempo, firmeza para proteger lo que más importa. Sabemos lo delicado de estos momentos.",
      "Te ofrecemos un acompañamiento humano y una representación legal clara en divorcios, pensiones, custodia y sucesiones en Puerto Vallarta.",
    ],
    includes: [
      "Divorcios voluntarios y necesarios",
      "Pensiones alimenticias",
      "Guarda y custodia y régimen de convivencia",
      "Sucesiones testamentarias e intestamentarias",
      "Convenios y mediación familiar",
    ],
    closing:
      "Defendemos tus derechos y los de tu familia con discreción, cercanía y estrategia.",
  },
  "derecho-mercantil": {
    slug: "derecho-mercantil",
    nav: "Derecho Mercantil",
    eyebrow: "ÁREA DE PRÁCTICA",
    h1: "Abogado Mercantil en Puerto Vallarta",
    title:
      "Abogado Mercantil en Puerto Vallarta | Sociedades y Litigio Comercial",
    description:
      "Derecho mercantil en Puerto Vallarta: constitución de sociedades, contratos comerciales, cobranza y litigio mercantil para negocios del mercado turístico.",
    keywords:
      "abogado mercantil Puerto Vallarta, constitución de sociedades, contratos comerciales, cobranza, litigio mercantil",
    intro: [
      "Operar un negocio en un mercado turístico exigente requiere estructuras legales sólidas y contratos que protejan tus intereses.",
      "Asesoramos a emprendedores y empresas en la constitución, operación y defensa de sus negocios en Puerto Vallarta y la Riviera Nayarit.",
    ],
    includes: [
      "Constitución de sociedades mercantiles",
      "Contratos comerciales y de prestación de servicios",
      "Cobranza judicial y extrajudicial",
      "Litigio mercantil",
      "Asesoría continua para negocios",
    ],
    closing:
      "Te ayudamos a estructurar tu empresa correctamente y a resolver los conflictos comerciales que se presenten.",
  },
  "derecho-corporativo": {
    slug: "derecho-corporativo",
    nav: "Derecho Corporativo",
    eyebrow: "ÁREA DE PRÁCTICA",
    h1: "Abogado Corporativo en Puerto Vallarta",
    title:
      "Abogado Corporativo en Puerto Vallarta | Gobierno y Cumplimiento",
    description:
      "Asesoría corporativa en Puerto Vallarta: gobierno corporativo, cumplimiento normativo y asesoría continua para empresas en crecimiento.",
    keywords:
      "abogado corporativo Puerto Vallarta, gobierno corporativo, cumplimiento normativo, compliance",
    intro: [
      "Las empresas en crecimiento necesitan un marco corporativo ordenado y en cumplimiento con la normativa vigente para operar con tranquilidad.",
      "Brindamos asesoría corporativa continua, dentro y fuera de la industria turística, para que tu empresa opere sobre bases legales firmes.",
    ],
    includes: [
      "Gobierno corporativo y órganos de administración",
      "Cumplimiento normativo (compliance)",
      "Actas, asambleas y libros corporativos",
      "Contratos y convenios entre socios",
      "Asesoría legal continua para empresas",
    ],
    closing:
      "Somos el aliado legal de tu empresa, con atención personalizada y visión de largo plazo.",
  },
};

export const SERVICE_ORDER = [
  "cancelacion-timeshare",
  "derecho-inmobiliario",
  "derecho-civil",
  "derecho-familiar",
  "derecho-mercantil",
  "derecho-corporativo",
];
